export enum InvoicePaymentStatus {
  PENDING = 'pending',
  FAILED = 'failed',
  PROCESSED = 'processed',
  CANCELLED = 'cancelled',
  DELETED = 'deleted',
  REVERSED = 'reversed'
}
